import React, { Component } from "react";
import { CLIENT_LIST, PLAN_STATUS_CHANGE, CLIENT_STATUS_UPDATE, GET_MASTER_SERVICE, FILTER_CHANGE_API, LOGIN_TYPE_ADMIN, Regenrate_Token,
  SERVICE13_TEXT,SERVICE18_TEXT,SERVICE21_TEXT,SERVICE28_TEXT,SERVICE29_TEXT,SERVICE30_TEXT,SERVICE32_TEXT,SERVICE36_TEXT,SERVICE14_TEXT,SERVICE20_TEXT
 } from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
import Parser from 'html-react-parser';
import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import { useSearchParams } from 'react-router-dom';
import UnAuthorised from "./UnAuthorised";
import Select2 from 'react-select2-wrapper';
import $ from "jquery";
import 'react-select2-wrapper/css/select2.css';
import { Alert } from 'rsuite';
import Header from "./include/Header";
import LoginAsClient from "./clientView/LoginAsClient";
const urlParams = new URLSearchParams(window.location.search);

class ClientList extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isDetailFound: null,
      bbuserAllClientList: [],
      masterServices: [],
      bbActiveService: [],
      businessname: [],
      clientID:[],
      userTokenEmail: '',
      userTokenUserId: '',
      EventValue: '',
      filters:{
        startpage:0,
        limit:10,
        paidType:'all',
        loginStatus:urlParams.get("loginStatus") || 'all',
        tokenStatus:urlParams.get("tokenStatus") || 'all',
        search:'all',
        totalCount:0,
        plan:urlParams.get("plan") || 'all'
      },
    };

  }

  componentDidMount() {
    //console.log(reactLocalStorage.get("authToken"));
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      this.loadClientListDetail();
      this.loadAllServices();
    }
    // $(document).ready(function () {
    //   $(".cancleButton").click(function () {
    //     $(".customPopup").hide();
    //   });
    // });
    
  }

  loadClientListDetail() {
    let parmes = '?limit='+this.state.filters.limit+'&skip='+(this.state.filters.limit * this.state.filters.startpage)+'&loginStatus='+this.state.filters.loginStatus+'&tokenStatus='+this.state.filters.tokenStatus+'&search='+this.state.filters.search+'&plan='+this.state.filters.plan;
    $(".loader").show();
    this.setState({
      bbuserAllClientList: []
    });
    Apihelpers.getdataresponse(CLIENT_LIST+parmes).then(res => {
      console.log('res.data',res.data);
      if (res.data.status === true) {
        let arrayList = [];
        res.data.data[0].businessname.forEach((item)=>{
          arrayList.push({id:item.id,text:item.text+' ('+item.id+')'+ '-'+item.email});
        })
        this.setState({
          isDetailFound: true,
          bbuserAllClientList: res.data.data[0].clientist,
          businessname: arrayList,
          filters:{...this.state.filters, totalCount:res.data.data[0].totalCount}
        });
        $(".loader").hide();
      } else {
        this.setState({
          isDetailFound: false,
        });
      }
    });
  }


  //currently not using
  loadAllServices() {
    Apihelpers.getdataresponse(GET_MASTER_SERVICE).then(res => {
      if (res.data.status === true) {
        //console.log('res.data.data',res.data.data);
        this.setState({
          masterServices: res.data.data,
          //isloaded: true
        });
      } else {
        this.setState({
          masterServices: []
        });
      }
    });
  }



  //plan checkbox rendring
  getPlanCheckbox(jsonParseservicelist, bbuserid) {
    const returnresult = jsonParseservicelist.map((single, index) => {
      return (
        <div className="row" key={index}>
          <div className="col">{single.plantype}</div>
          <div className="col-auto">
          {
            (single.isActive === 1) ?
            (<span className="col-status">Active</span>)
            : (single.isActive === 0) ?
            (<span className="col-status-in">InActive</span>)
            :
            ""
          }
          </div>
        </div>
      );
    });
    return returnresult;
  }


  //updated login status
  updateActiveStatus = (bbuid, e) => {
    if(bbuid === '5fed7790648ae566a563014c') {
      let statuswillbe = 'activate';
      if(e.target.checked === false) {
        statuswillbe = 'deactivate';
      }
      if (window.confirm("Are you sure you want to "+statuswillbe+" the TestingQA client? It will impact all services that are bound to this account") === false) {
        return;
      }
    }
    const statusChangeData = {
      ischecked: e.target.checked,
      buserid: bbuid
    };
    Apihelpers.postdataresponse(CLIENT_STATUS_UPDATE, statusChangeData).then(res => {
      if (res.data.status === true) {
        Alert.success(res.data.message);
        this.loadClientListDetail();
      }
    });
  }


  loadPage = (e) => {
    //console.log('e',e.target.getAttribute("data-i"));
    let start = Number(e.target.getAttribute("data-i"));
    this.setState({
      filters: {...this.state.filters, startpage: start}
    });
    setTimeout(()=>{
      this.loadClientListDetail();
    },100);
  }
  changeLimit = (e) => {
    let limit = Number(e.target.value);
    this.setState({
      filters: {
        startpage:0,
        limit:limit,
        paidType:'all',
        loginStatus:'all',
        tokenStatus:'all',
        search:'all',
        totalCount:0,
        plan:'all'
      }
    });
    setTimeout(()=>{
      this.loadClientListDetail();
    },100);
  }

  removeFilter = () => {
    this.setState({
      filters: {
        startpage:0,
        limit:10,
        paidType:'all',
        loginStatus:'all',
        tokenStatus:'all',
        search:'all',
        totalCount:0,
        plan:'all'
      }
    });
    urlParams.set('loginStatus', 'all');
    urlParams.set('tokenStatus', 'all');
    window.history.replaceState(null, null, '?'+urlParams.toString());
    setTimeout(()=>{
      this.loadClientListDetail();
    },100);
  }
  setClientId = () => {
    var businessname = $("#filterbusinessname").val();
    console.log('businessname',businessname);
    if (businessname !== null) {
      this.setState({filters: {...this.state.filters, search:businessname} });
    }
  }

  regenerateTokenForSingleClient = (clientEmail, user_id, e, is_active) => {
    e.preventDefault();
    if(is_active === true) {
      this.setState({ userTokenEmail: clientEmail, userTokenUserId: user_id, EventValue: e.target },
        () => {
          $("#infoPopUp1").show();
        });
    } else {
      $("#infoPopUp2").show();
    }
    console.log(e);
  }
  GenrateToken = () => {
    $(".customPopup").hide();
    const data = {
      emailId: this.state.userTokenEmail,
      userId: this.state.userTokenUserId
    };
    Apihelpers.postdataresponse(Regenrate_Token, data).then(res => {
      if (res.data.status === true) {
        Alert.success("API Authentication Token updated successfully.");
        //this.state.EventValue.checked = true;
        //console.log(this.state.EventValue);
        this.loadClientListDetail();
      }
    });
  }
  cancel = () => {
    $(".customPopup").hide();
  }

  
  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      const renderPaging = () => {
        let pages = (this.state.filters.totalCount / this.state.filters.limit);
        //console.log('pages',pages);
        let pagingHmtl = [];
        for (var i = 0; pages > i; i++ ) {
          pagingHmtl.push(<span key={i} data-i={i} className={(this.state.filters.startpage == i) ? 'btn active' : 'btn'} onClick={(e)=>{this.loadPage(e)}}>{i+1}</span>);
        }
        return pagingHmtl;
      }
      return (
        <React.Fragment>
          <div className="wrapper">
            <Header />
            <div className="container">
              <div className="clientListPage">
                <div className="titleBg">
                  <div className="row">
                    <div className="col">
                      <h3 className="title">Clients <span className="count">(Showing {this.state.bbuserAllClientList.length} out of {this.state.filters.totalCount} )</span></h3>
                    </div>
                    <div className="col-auto">
                      <NavLink className="createClientLink" to={"/admin/create-client"} > <i className="fa fa-plus"></i> Create Client</NavLink>
                    </div>
                  </div>
                </div>
                {
                  //JSON.stringify(this.state.filters,null,2)
                }
                {
                  //JSON.stringify(this.state.masterServices,null,2)
                }
                <div className="row">
                  <div className="col-12">
                    <div className="filterRow">
                      {/* <div className="form-group">
                        <select className="form-control">
                          <option>All</option>
                          <option>Postpaid</option>
                          <option>Prepaid</option>
                        </select>
                      </div> */}
                      <div className="form-group">
                        <select className="form-control" onChange={(e)=>{
                          this.setState({filters:{...this.state.filters, loginStatus:e.target.value, startpage:0}});
                          urlParams.set('loginStatus', e.target.value);
                          window.history.replaceState(null, null, '?'+urlParams.toString());
                        }} value={this.state.filters.loginStatus}>
                          <option value="all">All</option>
                          <option value="login-active"> Active</option>
                          <option value="login-inactive"> Inactive</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <select className="form-control" onChange={(e)=>{
                          this.setState({filters:{...this.state.filters, tokenStatus:e.target.value, startpage: 0}})
                          urlParams.set('tokenStatus', e.target.value);
                          window.history.replaceState(null, null, '?'+urlParams.toString());
                        }} value={this.state.filters.tokenStatus}>
                          <option value="all">All</option>
                          <option value="token-active">Token Active</option>
                          <option value="token-inactive">Token InActive</option>
                          {/* <option value="token-expire">Token will Expire</option> */}
                          {/* <option value="balance-exhausted">Balance Exhausted</option> */}
                        </select>
                      </div>
                      <div className="form-group">
                        <select className="form-control" onChange={(e)=>{
                          this.setState({filters:{...this.state.filters, plan:e.target.value, startpage: 0}})
                          urlParams.set('plan', e.target.value);
                          window.history.replaceState(null, null, '?'+urlParams.toString());
                        }} value={this.state.filters.plan}>
                          <option value="all">All</option>
                          {
                            (this.state.masterServices.length>0) ?
                              this.state.masterServices.map((pl)=>{
                                return(<option key={pl._id} value={pl.serviceName}>{pl.serviceName}</option>)
                              })
                            :
                            ''
                          }
                        </select>
                      </div>
                      <div className="form-group" style={{'width':'250px'}}>
                        <Select2
                          data={this.state.businessname}
                          options={{
                            placeholder: 'Search Business Name',
                          }}
                          id="filterbusinessname"
                          className="form-control"
                          value={this.state.filters.search}
                          onChange={()=>{this.setClientId()}}
                        />
                      </div>
                      <div className="form-group btnRow">
                        <button className="blueBtn" onClick={()=>{this.loadClientListDetail()}} type="button"><i className="fa fa-filter"></i></button>
                      </div>
                      <div className="form-group btnRow">
                        <button className="backBtn" onClick={()=>{this.removeFilter()}} type="button"><i className="fa fa-undo"></i></button>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="tableBorder">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Client Name, Unit <br />& Plans <span className="arrow"></span></th>
                          {/* <th>Plans</th>
                          <th>API Access</th> */}
                          {/* <th>Billed Amount</th>
                          <th>Per Hit <span className="small">(In Rs.)</span></th> */}
                          {/*<th>Payment Type</th>*/}
                          {/* <th>No of Hits</th> */}
                          <th>Client Email & ID</th>
                          <th>Panel User</th>
                          <th>Login Status</th>
                          <th>Token Status</th>
                          <th style={{"width":"130px"}}>Action</th>
                        </tr>
                        {this.state.bbuserAllClientList.length > 0 ?
                          this.state.bbuserAllClientList.map((singleclientlist, index) => {
                            //console.log('singleclientlist',singleclientlist);
                            //var bbuserinfoActivePlan = singleclientlist.bbuserInfo[0].active_plan ? JSON.parse(singleclientlist.bbuserInfo[0].active_plan) : '';
                            var serviceJsonParse = JSON.parse(singleclientlist.active_plan);
                            //var planDetail = this.getPaymentPlan(serviceJsonParse.service);
                            //var noofHitsbyplan = this.getApiHitHistoryData(singleclientlist.bbuserApiHitHistoryInfo, serviceJsonParse.service)

                            
                            var isPanelUser = "No";
                            serviceJsonParse.service.map((i) => {
                             if([SERVICE13_TEXT,SERVICE18_TEXT,SERVICE21_TEXT,SERVICE28_TEXT,SERVICE29_TEXT,SERVICE30_TEXT,SERVICE32_TEXT,SERVICE36_TEXT,SERVICE14_TEXT,SERVICE20_TEXT].includes(i.plantype)){
                                isPanelUser = 'Yes';
                             }
                            })

                            var planCheckboxList = "";
                            if (singleclientlist.is_active) {
                              planCheckboxList = this.getPlanCheckbox(serviceJsonParse.service, singleclientlist._id);
                            }

                            return (
                              <tr key={index}>
                                <td>
                                  {singleclientlist.is_active == true ?
                                    <NavLink
                                      title="Edit Pack"
                                      to={`${"/admin/client-edit-view/" + singleclientlist._id}`}
                                      exact
                                      activeClassName="active"
                                    >
                                      <strong>{singleclientlist.name}</strong>
                                    </NavLink>
                                    :
                                    <strong>{singleclientlist.name}</strong>
                                  }
                                  <span className="num" style={{'display':'inline-block'}}> &nbsp; 
                                  {singleclientlist.business_unit}
                                  </span>
                                  {/* <span className="num">{singleclientlist.invoice_number}</span> */}
                                  {singleclientlist.is_active == true ?
                                    (serviceJsonParse.service.length > 0) ?
                                    <div className="apiPlans">
                                      <span className="txt">API Plans & Access</span>
                                      <div className="toolTip">
                                        <i className="infoIcon"></i>
                                        <div className="toolTipText">
                                          {planCheckboxList}
                                        </div>
                                      </div>
                                    </div>
                                    : (<div className="apiPlans"><span className="txt" style={{color:'#7a7a7a'}}>Plan not assign</span></div>)
                                    : ""}
                                </td>
                                {/* <td><div>{Parser(planDetail[0])}</div></td>
                                <td>{planCheckboxList} </td> */}
                                {/* <td>{singleclientlist.is_active == true ?
                                  bbuserinfoActivePlan.balance : 0}</td>
                                <td><div>{Parser(planDetail[1])}</div></td> */}
                                {/*<td>{serviceJsonParse.plan_type}</td>*/}
                                {/* <td>{noofHitsbyplan}</td> */}
                                <td><span className="email">{singleclientlist.email}</span> {singleclientlist._id} </td>
                                <td>{isPanelUser}</td>
                                <td>
                                  <div className="equalCol">
                                    <label className="switch" >
                                      <input type="checkbox" onChange={(e) => this.updateActiveStatus(singleclientlist._id, e)} checked={singleclientlist.is_active} />
                                      <span className="slider round" />
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <div className="equalCol">
                                    <label className="switch" title={singleclientlist.isValidToken == true ? "Active Token" : "Expired token"} >
                                      <input type="checkbox" onChange={(e) => this.regenerateTokenForSingleClient(singleclientlist.email, singleclientlist._id, e, singleclientlist.is_active)} checked={singleclientlist.isValidToken } disabled={singleclientlist.isValidToken == true ? "disabled" : ""} />
                                      <span className="slider round" />
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  {singleclientlist.is_active == true ?
                                    <div className="icons">
                                      <NavLink
                                        title="Edit client"
                                        className="btnLink"
                                        to={`${"/admin/client-edit-view/" + singleclientlist._id}`}
                                        exact
                                        activeClassName="active"
                                      ><i className="fa fa-pencil"></i>
                                      </NavLink>
                                      <LoginAsClient clientId={singleclientlist._id}></LoginAsClient>
                                    </div>
                                    : null}
                                </td>
                              </tr>

                            )
                          })
                          :
                          <tr>
                            <td colSpan="9" align="center">
                              <img src="/assets/images/data-not-found-img.png" /><br /><br />
                              <b>No Data Found</b>
                            </td>
                          </tr>

                        }
                      </tbody>
                    </table>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="pageing">
                      {/* <span className="btn active">1</span>
                      <span className="btn">2</span>
                      <span className="btn">3</span>
                      <span className="btn">4</span> */}
                      {renderPaging()}
                    </div>
                  </div>
                  <div className="col-auto">
                    <select className="form-control" onChange={this.changeLimit} defaultValue={10}>
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="40">40</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
            <div className="loader">
              <div className="bg"></div>
              <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
            </div>
          </div>
          <div className="customPopup" id="infoPopUp1">
            <div className="bgLayer"></div>
            <div className="popUpBox">
              <div className="popScroll">
                <div className="infoMessagePopUp">
                  <div className="textA">API Authentication Token</div>
                  <div className="textB"> Do you really want to update API Authentication Token? </div>
                  <div className="submitRow">
                    <button className="backBtn" type="button" onClick={(e) => this.cancel(e)} >Cancel</button>
                    <button className="blueBtn okBtn" onClick={(e) => this.GenrateToken(e)} type="button">OK</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="customPopup" id="infoPopUp2">
            <div className="bgLayer"></div>
            <div className="popUpBox">
              <div className="popScroll">
                <div className="infoMessagePopUp">
                  <div className="textA">For API Authentication Token Active. You need to active login status active. </div>
                  <div className="submitRow">
                    <button className="blueBtn okBtn" onClick={() => {
                      $("#infoPopUp2").hide();
                    }} type="button">OK</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

export default ClientList;
